/* unplugin-vue-components disabled */import { render } from "./xsscewm.vue?vue&type=template&id=1b20560c&scoped=true"
import script from "./xsscewm.vue?vue&type=script&lang=js"
export * from "./xsscewm.vue?vue&type=script&lang=js"

import "./xsscewm.vue?vue&type=style&index=0&id=1b20560c&lang=less&scoped=true"

import exportComponent from "D:\\云盘\\SynologyDrive\\Synology Drive\\文件\\客户调查表\\customweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b20560c"]])

export default __exports__